'use client';

import React from 'react';

interface LoadingOverlayProps {
  isLoading: boolean;
  message?: string;
}

export default function LoadingOverlay({ isLoading, message = 'Loading...' }: LoadingOverlayProps) {
  if (!isLoading) return null;

  console.log('🎨 LoadingOverlay rendered - isLoading:', isLoading);

  return (
    <div 
      className="loading-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999999,
        animation: 'fadeIn 0.15s ease-in-out',
        pointerEvents: 'all',
      }}
    >
      {/* Modern Spinner */}
      <div 
        className="modern-spinner"
        style={{
          width: '60px',
          height: '60px',
          border: '4px solid rgba(255, 255, 255, 0.1)',
          borderTop: '4px solid #ffffff',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      
      {/* Message */}
      {message && (
        <p 
          className="mt-4 mb-0" 
          style={{ 
            fontSize: '1rem',
            fontWeight: 500,
            color: '#ffffff',
            letterSpacing: '0.5px',
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
            animation: 'fadeIn 0.4s ease-in-out',
          }}
        >
          {message}
        </p>
      )}
      
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
}

